<div [formGroup]="form">

  <input *ngIf="field.QuestionType == 'ShortAnswerCal' || field.QuestionType == 'ShortAnswerFormulaCal'"
         type="text"
         [id]="field.uniquename"
         [name]="field.uniquename"
         [formControlName]="field.uniquename"
         [placeholder]="field.QuestionText"
         [ngClass]="{'input-validation-error': isTouched && isInValid }"
         />

  <input *ngIf="field.QuestionType == 'MergeField' || field.QuestionType == 'ShortAnswer'"
         type="text"
         [id]="field.uniquename"
         [name]="field.uniquename"
         [formControlName]="field.uniquename"
         [placeholder]="field.QuestionText"
         [readonly]="isReadOnly"
         [ngClass]="{'input-validation-error': isTouched && isInValid }"/>

  <textarea *ngIf="field.QuestionType == 'LongAnswer'"
            [formControlName]="field.uniquename"
            [id]="field.uniquename"
            rows="9"
            [placeholder]="field.QuestionText"
            [ngClass]="{'input-validation-error': isTouched && isInValid }">
        </textarea>
</div>
<style>
  input[type=text] {
    max-width: 350px;
  }
</style>
